@if (page$(); as page) {
  <article class="overflow-hidden">
    <!--<app-header [title]="page.title" [image]="page.image" [intro]="page.intro"></app-header>-->
    @if (header()) {
      <app-header-content-page [header]="header()!"></app-header-content-page>
    }

    @if (page.text) {
      <section class="container pt-3 pt-md-4 section-inset-b">
        <ngx-dynamic-hooks
          class="markdown-content d-block text-max-width-sm mx-auto"
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="page.text | resizeHtmlImages | stripEmbed: cookiePreferences() || undefined"
          fstrDynamicContent
        ></ngx-dynamic-hooks>
      </section>
    }
  </article>
}
